export interface DomainAvailability {
  /**
   * Domain name including TLD. For example, `my-new-domain.com`.
   * @format HOSTNAME
   */
  domain?: string;
  /**
   * Whether the domain is available for purchase. You can purchase the
   * domain in case the boolean is `true`. The domain is already taken
   * when `false` is returned.
   */
  available?: boolean;
  /** Whether the domain has a higher price due to its perceived value or demand. */
  premium?: boolean;
  /**
   * In case the domain is premium the premium_type will represent the type of the premium domain.
   * FIRST_YEAR_ONLY - only initial purchase price is  premium while the renewal will cost the regular price of the TLD.
   * FIRST_YEAR_AND_RENEWAL - both initial purchase and renewal prices are premium.
   */
  premiumType?: PremiumTypeWithLiterals;
}

export enum PremiumType {
  FIRST_YEAR_ONLY = 'FIRST_YEAR_ONLY',
  FIRST_YEAR_AND_RENEWAL = 'FIRST_YEAR_AND_RENEWAL',
}

/** @enumType */
export type PremiumTypeWithLiterals =
  | PremiumType
  | 'FIRST_YEAR_ONLY'
  | 'FIRST_YEAR_AND_RENEWAL';

export interface CheckDomainAvailabilityRequest {
  /**
   * Domain name. Must include the TLD. For example, `my-new-domain.com`. Only
   * alphanumeric characters, hyphens, and dots are supported.
   *
   * Min: 3 characters
   * Max: 63 characters
   * @format HOSTNAME
   */
  domain: string;
}

export interface CheckDomainAvailabilityResponse {
  /** Information about the domain's availability. */
  availability?: DomainAvailability;
}
